import {Injectable} from '@angular/core';
import {FirestoreAuthErrorsEnum} from '../enum';
import {ToastProvider} from '../providers';
import {EmailAlreadyExistError, PhoneNumberAlreadyExistError} from '../../shared/errors';
import {Router} from '@angular/router';

@Injectable({
  providedIn: 'root'
})
export class HandleErrorsService {
  constructor(
    private toastProvider: ToastProvider,
    private router: Router,
  ) {
  }

  async authError(error: any) {
    console.error('Handle Error', error.message);
    console.error('Error Code:', error.code);
    console.error('Full Error:', JSON.stringify(error));
    if (error instanceof EmailAlreadyExistError) {
      await this.toastErrorMessage('This email address is already associated with a different account.');
    } else if (error instanceof PhoneNumberAlreadyExistError) {
      await this.toastErrorMessage('This phone number is already associated with a different account.');
    } else {
      switch (error.code) {
        case FirestoreAuthErrorsEnum.accountExistsWithDifferentCredential:
          await this.toastErrorMessage('This phone number is already linked to another account. Please sign in with that account.');
          break;
        case FirestoreAuthErrorsEnum.credentialAlreadyInUse:
          await this.toastErrorMessage('This credential is already in use. Please use a different credential.');
          break;
        case FirestoreAuthErrorsEnum.emailAlreadyInUse:
          await this.toastErrorMessage('This email address is already in use.');
          break;
        case FirestoreAuthErrorsEnum.invalidCredential:
          await this.toastErrorMessage('The credential is malformed or has expired. Please check and try again.');
          break;
        case FirestoreAuthErrorsEnum.invalidEmail:
          await this.toastErrorMessage('The email address you entered is invalid.');
          break;
        case FirestoreAuthErrorsEnum.invalidVerificationCode:
          await this.toastErrorMessage('The verification code you entered is invalid.');
          break;
        case FirestoreAuthErrorsEnum.invalidVerificationId:
          await this.toastErrorMessage('The verification ID you entered is invalid.');
          break;
        case FirestoreAuthErrorsEnum.noSuchProvider:
          await this.toastErrorMessage('The specified provider is not supported.');
          break;
        case FirestoreAuthErrorsEnum.operationNotAllowed:
          await this.toastErrorMessage('This operation is not currently allowed. Please contact support for assistance.');
          break;
        case FirestoreAuthErrorsEnum.providerAlreadyLinked:
          await this.toastErrorMessage('This phone number is already linked to your account.');
          break;
        case FirestoreAuthErrorsEnum.userDisabled:
          await this.toastErrorMessage('Your account has been blocked. Please contact support for assistance.');
          await this.router.navigate(['/login-restricted']);
          break;
        case 'user-disabled':
          console.log('user is blocked');

          await this.toastErrorMessage('Your account has been blocked. Please contact support for assistance.');
          await this.router.navigate(['/login-restricted']);
          break;
        case FirestoreAuthErrorsEnum.userMismatch:
          await this.toastErrorMessage('The email address you entered is associated with a different account.');
          break;
        case FirestoreAuthErrorsEnum.userNotFound:
          await this.toastErrorMessage('We could not find an account with the email address you entered.');
          break;
        case FirestoreAuthErrorsEnum.userTokenExpired:
          await this.toastErrorMessage('Your login session has expired. Please log in again.');
          break;
        case FirestoreAuthErrorsEnum.wrongPassword:
          await this.toastErrorMessage('The username or password you entered is incorrect.');
          break;
        case FirestoreAuthErrorsEnum.tenantIdMismatch:
          await this.toastErrorMessage('The user\'s tenant ID does not match the authenticated tenant ID.');
          break;
        case FirestoreAuthErrorsEnum.nullUser:
          await this.toastErrorMessage('The user object is null. Please check and try again.');
          break;
        case FirestoreAuthErrorsEnum.authUnknown:
          await this.toastErrorMessage('An unknown error occurred. Please try again later or contact support for assistance.');
          break;
        case FirestoreAuthErrorsEnum.requiresRecentLogin:
          await this.toastErrorMessage('Authentication requires recent login. Please log in again to continue');
          break;
        case FirestoreAuthErrorsEnum.weakPassword:
          await this.toastErrorMessage('The password you entered is too weak. Please choose a stronger password.');
          break;
        case FirestoreAuthErrorsEnum.popupClosedByUser:
          await this.toastErrorMessage('Uh-oh! Looks like you closed the authentication window.');
          break;
        case FirestoreAuthErrorsEnum.invalidPhoneNumber:
          await this.toastErrorMessage('The phone number you entered is invalid.');
          break;
        case FirestoreAuthErrorsEnum.tooManyRequests:
          await this.toastErrorMessage('Too many requests. Please try again later.');
          break;
        case FirestoreAuthErrorsEnum.quotaExceeded:
          await this.toastErrorMessage('Service temporarily unavailable. Please try again later.');
          break;
        case FirestoreAuthErrorsEnum.networkRequestFailed:
          await this.toastErrorMessage('Network error. Please check your internet connection and try again.');
          break;
        case FirestoreAuthErrorsEnum.captchaCheckFailed:
          await this.toastErrorMessage('Verification failed. Please try again.');
          break;
        case FirestoreAuthErrorsEnum.missingPhoneNumber:
          await this.toastErrorMessage('Please enter a valid phone number.');
          break;
        case FirestoreAuthErrorsEnum.codeExpired:
          await this.toastErrorMessage('The verification code has expired. Please request a new one.');
          break;
        case FirestoreAuthErrorsEnum.sessionExpired:
          await this.toastErrorMessage('Your session has expired. Please try again.');
          break;
        case FirestoreAuthErrorsEnum.internalError:
          await this.toastErrorMessage('An internal error occurred. Please try again later.');
          break;
        default:
          await this.toastErrorMessage(`Something went wrong! (${error.code || 'unknown'})`);
          break;
      }
    }
  }

  private async toastErrorMessage(message: string) {
    await this.toastProvider.presentToast({
      message,
      color: 'danger',
      duration: 6000,
      buttons: [{
        icon: 'close-outline',
        role: 'cancel',
      }]
    });
  }
}
